import clsx from "clsx";
import type { DealSummary } from "@edge/shared";
import { Panel } from "../shared/Panel";
import { StatusDot } from "../shared/StatusDot";

interface DealsStripProps {
  deals: DealSummary[];
  onSelect?: (dealId: string) => void;
}

function formatAmount(amount: number | null): string {
  if (amount == null) return "—";
  if (amount >= 1_000_000) {
    const m = amount / 1_000_000;
    return `$${m % 1 === 0 ? m.toFixed(0) : m.toFixed(1)}M`;
  }
  return `$${Math.round(amount / 1000)}K`;
}

export function DealsStrip({ deals, onSelect }: DealsStripProps) {
  const activeCount = deals.length;
  return (
    <Panel
      className="deals-strip"
      title="OPEN DEALS"
      count={`${activeCount} ACTIVE`}
      bodyless
    >
      <div className="deals-scroll">
        {deals.map((d) => (
          <DealCard key={d.id} deal={d} onSelect={onSelect} />
        ))}
      </div>
    </Panel>
  );
}

function DealCard({
  deal,
  onSelect,
}: {
  deal: DealSummary;
  onSelect?: (dealId: string) => void;
}) {
  return (
    <div
      className={clsx("deal-card", deal.urgent && "urgent")}
      onClick={() => onSelect?.(deal.id)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect?.(deal.id);
        }
      }}
    >
      <div className="deal-name">{deal.name}</div>
      <div className="deal-stage">{deal.stage}</div>
      <div className="deal-meta">
        <span className="deal-amount">{formatAmount(deal.amount)}</span>
        <span>{deal.closeDate ?? "Close TBD"}</span>
      </div>
      <div className="deal-dots">
        <StatusDot info={deal.dots.watch} label="WTCH" />
        <StatusDot info={deal.dots.tsk} label="TSK" />
      </div>
    </div>
  );
}
